export default "__VITE_ASSET__roIXaaGE__"